import React from 'react'
import { Input } from '../../components/ui'
import {
  BR_UFS,
  SELECT_CLASS,
  TEXTAREA_CLASS,
  type EstoqueFornecedorFormValues,
} from './estoqueUi'

type Props = {
  form: EstoqueFornecedorFormValues
  onChange: (next: EstoqueFornecedorFormValues) => void
  /** Exibe o checkbox "Ativo" (edição na aba de fornecedores). */
  showActive?: boolean
}

const EstoqueFornecedorFormFields: React.FC<Props> = ({
  form,
  onChange,
  showActive = false,
}) => {
  const patch = (partial: Partial<EstoqueFornecedorFormValues>) =>
    onChange({ ...form, ...partial })

  return (
    <>
      <div>
        <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Nome <span className="text-red-500">*</span>
        </label>
        <Input
          value={form.name}
          onChange={(e) => patch({ name: e.target.value })}
          required
        />
      </div>
      <div>
        <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Endereço
        </label>
        <textarea
          value={form.address}
          onChange={(e) => patch({ address: e.target.value })}
          rows={2}
          placeholder="Rua, número, bairro"
          className={TEXTAREA_CLASS}
        />
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-[1fr_7rem]">
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Cidade
          </label>
          <Input value={form.city} onChange={(e) => patch({ city: e.target.value })} />
        </div>
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
            UF
          </label>
          <select
            value={form.state}
            onChange={(e) => patch({ state: e.target.value })}
            className={`${SELECT_CLASS} w-full`}
          >
            <option value="">—</option>
            {BR_UFS.map((uf) => (
              <option key={uf} value={uf}>
                {uf}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Contato
          </label>
          <Input
            value={form.contact_name}
            onChange={(e) => patch({ contact_name: e.target.value })}
          />
        </div>
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Telefone
          </label>
          <Input value={form.phone} onChange={(e) => patch({ phone: e.target.value })} />
        </div>
        <div>
          <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
            E-mail
          </label>
          <Input
            type="email"
            value={form.email}
            onChange={(e) => patch({ email: e.target.value })}
          />
        </div>
      </div>
      <div>
        <label className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Observações
        </label>
        <textarea
          value={form.notes}
          onChange={(e) => patch({ notes: e.target.value })}
          rows={3}
          className={TEXTAREA_CLASS}
        />
      </div>
      {showActive && (
        <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
          <input
            type="checkbox"
            checked={form.is_active}
            onChange={(e) => patch({ is_active: e.target.checked })}
            className="rounded border-gray-300 text-primary-600 focus:ring-primary-500"
          />
          Ativo
        </label>
      )}
    </>
  )
}

export default EstoqueFornecedorFormFields
